import { ThemeButton, ThemeButtonIcon } from '@shared/ui/buttons';
import { useSelector } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';
import { theme } from '@utils/libs/theme';

export default function TelegramBtn({
  text = 'Telegram',
  appearance = 'secondary',
  startIcon = 'telegram',
  username,
  changeOnMobile = false,
}) {
  const { configs } = useSelector((state) => state.configs);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const href = username ? `https://t.me/${username}` : configs.support_telegram;

  return isMobile && changeOnMobile ? (
    <ThemeButtonIcon as="a" href={href} target="_blank" icon={startIcon} />
  ) : (
    <ThemeButton
      as="a"
      href={href}
      target="_blank"
      appearance={appearance}
      startIcon={startIcon}
    >
      {text}
    </ThemeButton>
  );
}
